import { IConfigsType } from '../../types'

const fwWingstopCalls: IConfigsType = {
  'fw_wingstop-corporate-base-zj8m1ewp': {
    '/:brand/corporate_calls': {
      feV2: {
        type: 'FE V2',
        configPath: 'fw_wingstop/corporate_calls',
        height: '100vh',
      },
    },
  },
  'fw_wingstop-store-base-r3d9tnva': {
    '/:brand/calls': {
      feV2: {
        type: 'FE V2',
        configPath: 'fw_wingstop/calls',
        height: '100vh',
      },
    },
  },
}

export default fwWingstopCalls
